import React from 'react';
import ja_rubies from '../locales/ja/rubies.json';
import { getLanguage } from '../utils/cardUtils.js';
import './CardNameWithRuby.css';

/**
 * [漢字|よみ] 記法をパースして <ruby> タグを含む要素配列を生成する
 * 例: "[聖|せい]なる[領域|りょういき]" -> [<ruby>聖<rt>せい</rt></ruby>, <span className="ruby-text">なる</span>, <ruby>領域<rt>りょういき</rt></ruby>]
 */
function parseRubyText(rubyText) {
  const regex = /\[([^|]+)\|([^\]]+)\]/g;
  const elements = [];
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(rubyText)) !== null) {
    if (match.index > lastIndex) {
      elements.push(
        <span key={`text-${match.index}`} className="ruby-text">
          {rubyText.substring(lastIndex, match.index)}
        </span>
      );
    }
    const kanji = match[1];
    const reading = match[2];
    elements.push(
      <ruby key={match.index}>
        {kanji}
        <rt>{reading}</rt>
      </ruby>
    );
    lastIndex = regex.lastIndex;
  }

  if (lastIndex < rubyText.length) {
    elements.push(
      <span key={`text-${lastIndex}`} className="ruby-text">
        {rubyText.substring(lastIndex)}
      </span>
    );
  }

  return elements;
}

/**
 * 日本語設定時にカード名の漢字へフリガナ（ルビ）を充てて描画するコンポーネント。
 * 辞書に未登録のカードや日本語以外の環境では、fallbackName をそのまま描画します。
 */
const CardNameWithRuby = ({ cardId, fallbackName, className = '' }) => {
  const currentLang = getLanguage();

  if (currentLang === 'ja') {
    const rubyDefinition = ja_rubies[cardId?.toString()];
    if (rubyDefinition) {
      return (
        <span className={`card-name-with-ruby ${className}`.trim()}>
          {parseRubyText(rubyDefinition)}
        </span>
      );
    }
  }

  return <span className={className}>{fallbackName}</span>;
};

export default CardNameWithRuby;
